// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YSzP","question":"styles_question__1ebzU","description":"styles_description__344mf"};